/*
 * @Description: 原生录音相关api
 */

import utils from '../index'
import h5Api from './h5-others'
import xbb from '@xbb/xbb-utils'

const noop = function () {}

// 录音结束的成功回调
let successFun = noop
// 录音结束的失败回调
let failFun = noop

function getFileForAndroid10Plus(file) {
  const { fullPath, name } = file
  const system = xbb.browser()
  if (system === 'ios') throw new Error('上传失败，请重新尝试')
  const NjsTest = window.plus.android.importClass('com.pactera.xbcrm.recorder.bridge.JsInterface')
  const activity = window.plus.android.runtimeMainActivity()
  const jsInterface = new NjsTest(activity)
  const data = jsInterface.imageToDataURL(fullPath)
  return utils.dataURLtoFile(data, name)
}

function getNewFile(file, evt) {
  // 独立版、飞书上传文件的特殊操作，将base64转为file
  if (xbb._get(evt, 'target.result', undefined)) {
    return utils.dataURLtoFile(evt.target.result, file.name)
    // 安卓10+上传文件的特殊操作
  } else if (xbb._get(evt, 'target.error', undefined)) {
    return getFileForAndroid10Plus(file)
  } else {
    return file
  }
}

// 获取指定的目录或文件操作对象
function resolveLocalFile(mediaId) {
  // resolveLocalFileSystemURL: 快速获取指定的目录或文件操作对象，如通过URL值“_www/test.html”可直接获取文件操作对象
  window.plus.io.resolveLocalFileSystemURL(
    `${mediaId}`,
    (entry) => {
      entry.file((file) => {
        const fileReader = new window.plus.io.FileReader()
        fileReader.onloadend = function (evt) {
          successFun(getNewFile(file, evt))
        }
        fileReader.readAsDataURL(file)
      })
    },
    (err) => {
      failFun('Resolve file URL failed: ' + err.message)
    }
  )
}

/**
 * 开始录音
 * @param {any} drawRecord // H5调用权限成功后需要的动画等其他操作
 * @param {any} onSuccess
 */

const xbbRecordStart = function ({ drawRecord, onSuccess }) {
  h5Api.h5ChoosePermission({
    type: 4,
    onSuccess: (isAuthorized) => {
      const format = 'mp3'
      if (isAuthorized) {
        drawRecord()
        if (!window.r) window.r = window.plus.audio.getRecorder()
        window.r.record(
          { format },
          (res) => {
            onSuccess(res)
            // 录音成功后通过路径读取文件并上传到oss
            resolveLocalFile(res)
          },
          (err) => console.log('err', err)
        )
      } else {
        window.r = window.plus.audio.getRecorder()
        window.r.record({ format }, (result) => h5Api.h5DelFile({ path: result }))
        window.r.stop()
      }
    }
  })
}

/**
 * 停止录音
 * @param {any} onSuccess
 * @param {any} onFail
 */
const xbbRecordStop = function ({ onSuccess, onFail }) {
  successFun = onSuccess
  failFun = onFail
  window.r.stop()
}

const xbbRecordPause = function () {
  window.r.pause()
}

const xbbRecordResume = function () {
  window.r.resume()
}

export default {
  xbbRecordStart,
  xbbRecordStop,
  xbbRecordPause,
  xbbRecordResume
}
